import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-slate-900 py-20 px-4 border-y border-slate-800" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <div className="bg-red-500/5 border border-red-500/20 rounded-2xl p-8 mb-12" data-id="element-113">
          <div className="flex items-start gap-4" data-id="element-114">
            <AlertTriangle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-115" />
            <div data-id="element-116">
              <h3 className="text-xl font-bold text-red-500 mb-2 uppercase" data-id="element-117">
                Advertencia
              </h3>
              <p className="text-slate-300" data-id="element-118">
                Si estás buscando motivación barata o frases de "vibra alto",
                cierra esta página. Esto es ingeniería mental pura y dura.
              </p>
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-119">
          ¿SIENTES QUE TE ESTÁS QUEDANDO ATRÁS...{' '}
          <span className="text-red-500" data-id="element-120">AUNQUE TRABAJAS MÁS QUE NADIE?</span>
        </h2>

        <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-121">
          <p data-id="element-122">
            Vives en el país de las oportunidades, hablas el idioma del éxito, y
            sigues todas las reglas. Tienes el carro, el trabajo estable o el
            negocio que "sobrevive".
          </p>
          <p className="font-medium text-white border-l-4 border-yellow-500 pl-4" data-id="element-123">
            En papel, vas por buen camino. Pero cuando apagas la luz, sabes la
            verdad:{' '}
            <span className="text-yellow-500" data-id="element-124">Estás operando al 20%.</span>
          </p>
          <p data-id="element-125">
            Esa sensación de vacío no es depresión. Es tu{' '}
            <strong data-id="element-126">Identidad de Ganador</strong> gritando porque la tienes
            atrapada en un software de "buen empleado" que ya no te queda.
          </p>
          <p data-id="element-127">
            Te enseñaron a ser agradecido, a no causar problemas y a esperar tu
            turno.
          </p>

          <div className="bg-slate-950 p-6 rounded-xl border border-slate-800 mt-8" data-id="element-128">
            <div className="flex items-center gap-3 text-white font-bold text-xl mb-2" data-id="element-129">
              <XCircle className="text-red-500" data-id="element-130" />
              La Cruda Realidad:
            </div>
            <p className="text-slate-400" data-id="element-131">
              En Estados Unidos, si esperas tu turno,{' '}
              <span className="text-white underline decoration-red-500 decoration-2" data-id="element-132">
                te quedas con las sobras.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}